import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import SvgIconApp from '@material-ui/icons/Apps';
import SvgViewer from '@material-ui/icons/Explore';
import SvgTasking from '@material-ui/icons/CreateNewFolder';
import SvgReport from '@material-ui/icons/Assignment';
import SvgSettings from '@material-ui/icons/Settings';
import SvgFAQ from '@material-ui/icons/LiveHelp';

import PopoverMenu from './Popover'
import AppButton from './AppButton'

const styles = (theme) => {
    return {
        iconButton: {
            position: 'relative',
            marginTop: 0,
            marginBottom: 0,
            padding: 0,
            width: 36,
            height: 36,
        },
        icon: {
            ...theme.iconStyle.size[28],
            ...theme.iconStyle.light,
            margin: 4,
        },
        popover: {
            marginRight: 55,
        },
        appContainer: {
            position: 'relative',
            width: 302,
        },
        appBorder: {
            width: '100%',
            height: 25,
        },
        appRegion: {
            width: 'calc(100% - 50px)',
            paddingTop: 25,
            paddingLeft: 25,
            paddingRight: 25,
            paddingBottom: 25,
            textAlign: 'left',
        },
        appIcon: {
            ...theme.iconStyle.size[48],
            ...theme.iconStyle.light,
            marginTop: 4,
        },
        appLabel: {
            marginTop: 4,
            marginBottom: 4,
            marginLeft: 4,
            marginRight: 4,
            color: theme.palette.primary.displayText,
            fontSize: 12,
        },
        tempClass: {
            width: 200,
            height: 200,
        }
    }
}

class Navigation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.state.open !== nextState.open);
    }

    render = () => {
        const {classes} = this.props;

        return (
            <div>
                <Tooltip
                    id='tooltip-app'
                    title='App Drawer'
                    enterDelay={500}
                >
                    <IconButton
                        className={classes.iconButton}
                        onClick={this._handleClick}
                    >
                        <SvgIconApp className={classes.icon}/>
                    </IconButton>
                </Tooltip>
                <PopoverMenu
                    className={classes.popover}
                    open={this.state.open}
                    onClose={this._handleClose}
                >
                    <div className={classes.appContainer}>
                        <div className={classes.appRegion}>
                            {this.props.appList.map(this._renderListItem)}
                        </div>
                    </div>
                </PopoverMenu>
            </div>
        );
    }

    click = () => {
        this.setState({
            open: !this.state.open,
        });
    }

    _renderListItem = (data, index, arr) => {
        switch (data) {
            case 'viewer':
                return this._renderViewer();
            case 'tasking':
                return this._renderTasking();
            case 'report':
                return this._renderReport();
            case 'settings':
                return this._renderSettings();
            case 'faq':
                return this._renderFAQ()
            default:
                return null;
        }
    }

    _renderViewer = () => {
        const {classes} = this.props;

        return (
            <AppButton
                value='viewer'
                onClick={this._onChange}
            >
                <SvgViewer className={classes.appIcon}/>
                <Typography
                    className={classes.appLabel}
                    align='center'
                >
                    Viewer
                </Typography>
            </AppButton>
        );
    }

    _renderTasking = () => {
        const {classes} = this.props;

        return (
            <AppButton
                value='tasking'
                onClick={this._onChange}
            >
                <SvgTasking className={classes.appIcon}/>
                <Typography
                    className={classes.appLabel}
                    align='center'
                >
                    Tasking
                </Typography>
            </AppButton>
        );
    }

    _renderReport = () => {
        const {classes} = this.props;

        return (
            <AppButton
                value='report'
                onClick={this._onChange}
            >
                <SvgReport className={classes.appIcon}/>
                <Typography
                    className={classes.appLabel}
                    align='center'
                >
                    Report
                </Typography>
            </AppButton>
        );
    }

    _renderSettings = () => {
        const {classes} = this.props;

        return (
            <AppButton
                value='settings'
                onClick={this._onChange}
            >
                <SvgSettings className={classes.appIcon}/>
                <Typography
                    className={classes.appLabel}
                    align='center'
                >
                    Settings
                </Typography>
            </AppButton>
        );
    }

    _renderFAQ = () => {
        const {classes} = this.props;

        return (
            <AppButton
                value='faq'
                onClick={this._onChange}
            >
                <SvgFAQ className={classes.appIcon}/>
                <Typography
                    className={classes.appLabel}
                    align='center'
                >
                    FAQ
                </Typography>
            </AppButton>
        );
    }

    _handleClick = (e) => {
        e.preventDefault();

        this.setState({
            open: true,
        });
    }

    _handleClose = (e) => {
        e.preventDefault();

        this.setState({
            open: false,
        });
    }

    _onChange = (e, value) => {
        this._handleClose(e);

        if (this.props.onChange) {
            this.props.onChange(e, value);
        }
    }
}

Navigation.propTypes = {
    appList: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
}

export default withStyles(styles)(Navigation);
